import React, { useMemo, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import * as Styled from './MessageFields.styles';

import * as FormStyled from '+/styles/styledComponents/Form.styles';
import { t } from '+/utils/textDictionary';

export const MessageFields = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  intro,
  outro,
  subjectInputRef,
  variant = 'capped',
}: MessageFieldsProps) => {
  const [uniqueId] = useState(uuidv4);
  const subjectInputId = useMemo(() => `input-${uniqueId}-subject`, [uniqueId]);
  const messageInputId = useMemo(() => `input-${uniqueId}-message`, [uniqueId]);

  const outroName = `${values.FirstName || `[${t('EAPetitionForm.FirstName')}]`} ${
    values.LastName || `[${t('EAPetitionForm.LastName')}]`
  }`;

  return (
    <>
      <Styled.FieldRow>
        <Styled.InputLabel fullWidth errored={!!errors.Subject0} htmlFor={subjectInputId}>
          <Styled.InputLabelText>{t('EAAdvocacyForm.Subject')}:</Styled.InputLabelText>
          <Styled.SubjectInput
            name="Subject0"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.Subject0}
            placeholder={`${t('EAAdvocacyForm.Subject')}*`}
            id={subjectInputId}
            ref={subjectInputRef}
          />
          {touched.Subject0 && errors.Subject0 && (
            <FormStyled.InputError>{errors.Subject0}</FormStyled.InputError>
          )}
        </Styled.InputLabel>
      </Styled.FieldRow>
      <Styled.MessageFieldRow variant={variant}>
        <Styled.InputLabel fullWidth errored={!!errors.Message0} htmlFor={messageInputId}>
          <Styled.InputLabelText>{t('EAAdvocacyForm.Message')}:</Styled.InputLabelText>
          <Styled.TextAreaContainer variant={variant}>
            <Styled.Intro>{intro || t('EAAdvocacyForm.MessagePrefix')}</Styled.Intro>
            <Styled.TextArea
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.Message0}
              name="Message0"
              placeholder={`${t('EAAdvocacyForm.Message')}*`}
              id={messageInputId}
            />
            <Styled.Outro>
              {outro
                ? outro.replace('[Your information here]', outroName)
                : t('EAAdvocacyForm.MessageSuffix', { name: outroName })}
            </Styled.Outro>
          </Styled.TextAreaContainer>
          {touched.Message0 && errors.Message0 && (
            <FormStyled.InputError>{errors.Message0}</FormStyled.InputError>
          )}
        </Styled.InputLabel>
      </Styled.MessageFieldRow>
    </>
  );
};
